
export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/caffe02259a8f3afe3d14c5a8a93739e.jpg"
          alt="オフィス環境"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center w-full">
        <div className="inline-block bg-blue-600 text-white px-6 py-2 rounded-full text-sm font-bold mb-6">
          法人限定
        </div>
        
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          業界No.1のレンタルプリンター
        </h1>
        
        <div className="text-4xl md:text-6xl font-bold text-white mb-4">
          <span className="text-yellow-400">フルカラーが定額制</span>
        </div>
        
        <p className="text-3xl md:text-5xl font-bold text-white mb-8">
          印刷し放題の「スリホ」
        </p>

        <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-8 max-w-md mx-auto mb-12 shadow-2xl">
          <div className="flex items-center justify-center mb-4">
            <div className="text-sm text-gray-600 font-medium">導入実績</div>
          </div>
          <div className="text-5xl font-bold text-blue-600 mb-2">5,000社以上</div>
        </div>

        <div className="space-y-4 text-white text-lg mb-12">
          <p className="flex items-center justify-center gap-2">
            <i className="ri-check-line text-2xl text-blue-400"></i>
            <span>必要なのは定額の月額料金だけ！</span>
          </p>
          <p className="flex items-center justify-center gap-2">
            <i className="ri-check-line text-2xl text-blue-400"></i>
            <span>修理代<span className="text-yellow-400 font-bold">定額無料</span></span>
          </p>
          <p className="flex items-center justify-center gap-2">
            <i className="ri-check-line text-2xl text-blue-400"></i>
            <span>プラン変更<span className="text-yellow-400 font-bold">無料</span></span>
          </p>
          <p className="flex items-center justify-center gap-2">
            <i className="ri-check-line text-2xl text-blue-400"></i>
            <span>本体交換<span className="text-yellow-400 font-bold">無料</span></span>
          </p>
          <p className="flex items-center justify-center gap-2">
            <i className="ri-check-line text-2xl text-blue-400"></i>
            <span>専属サポート<span className="text-yellow-400 font-bold">無料</span></span>
          </p>
          <p className="flex items-center justify-center gap-2">
            <i className="ri-check-line text-2xl text-blue-400"></i>
            <span>ネットワークトラブル<span className="text-yellow-400 font-bold">出張無料</span></span>
          </p>
          <p className="flex items-center justify-center gap-2">
            <i className="ri-check-line text-2xl text-blue-400"></i>
            <span>13時までのご連絡で<span className="text-yellow-400 font-bold">当日発送</span></span>
          </p>
        </div>

        <a 
          href="#contact" 
          className="inline-block bg-blue-600 text-white px-12 py-5 rounded-full text-xl font-bold hover:bg-blue-700 transition-all transform hover:scale-105 shadow-2xl whitespace-nowrap"
        >
          今すぐ無料相談
        </a>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-white"></i>
      </div>
    </section>
  );
}
